// @flow

export { default } from './LogoImage';
